import React, { useContext, useEffect, useState } from "react";
import {
  AccountBenefits,
  determineAccountBenefitsType,
} from "./AccountBenefits";
import { getQueryStringParams } from "@theatticusapp/atticus-shared-components";
import { Theme, Grid } from "@mui/material";
import { HostedAuth } from "./HostedAuth";
import { LeadAuthProbate } from "./LeadAuthProbate";
import { EnvironmentInputs } from "./EnvironmentInputs";
import { PreProdOnlyWrapper } from "../shared/PreProdOnlyWrapper";
import { Helmet } from "react-helmet";
import { LeadProbateContext } from "LeadProbateContextWrapper";
import { ProbateDetails } from "models/ProbateDetails";
import { Loading } from "views/shared/Loading";
import { LeadContext } from "LeadContextWrapper";
import { CasperBanner } from "components/CasperBanner";

export const AuthScreen = (): JSX.Element => {
  const params = getQueryStringParams();
  const { getProbateDetails } = useContext(LeadProbateContext)
  const { lead, leadData } = useContext(LeadContext)
  const origin = params?.origin || undefined;
  const feature = params?.feature || undefined;
  const forProbateLead = params?.lead_forms === "true"
  const benefitsType = forProbateLead ? undefined : determineAccountBenefitsType({ origin, feature });
  const [probateDetails, setProbateDetails] = useState<ProbateDetails | undefined>(undefined)

  useEffect(() => {
    const getDetails = async () => {
      if (!getProbateDetails) {
        return
      }
      if (probateDetails?.probateType) {
        return
      }

      const probateDetailResponse = await getProbateDetails();
      setProbateDetails(probateDetailResponse);
    }
    forProbateLead && getDetails()
  }, [lead?.key, leadData, getProbateDetails]);

  return (
    <>
      <Helmet>
        <title>Atticus Authentication</title>
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{
          background: forProbateLead ? "linear-gradient(135deg, #734ed2, #5e78e7)" : "background.default",
          padding: forProbateLead ? "4rem" : "10rem 4rem 4rem 4rem",
        }}>
          {forProbateLead && !probateDetails && <Loading />}
          {(!forProbateLead || probateDetails) && <>
            {forProbateLead ?
              <div style={{ paddingTop: "3rem", height: "100%" }}>
                <LeadAuthProbate numForms={probateDetails?.probateType?.numProbateForms || 0} />
              </div> :
              <AccountBenefits benefit={benefitsType} />}
          </>}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ backgroundColor: "white", display: "flex", padding: "6rem 3rem 6rem 3rem", justifyContent: "center" }}>
          <div style={{ display: "flex", minWidth: "80%" }}>
            <HostedAuth leadKey={lead?.key || ""} headerText={forProbateLead ? "Create an account to access your results" : undefined} />
          </div>
        </Grid>
      </Grid>
      <PreProdOnlyWrapper>
        <EnvironmentInputs />
      </PreProdOnlyWrapper>
    </>
  );
};

// https://www.npmjs.com/package/react-material-ui-carousel
export const getCarouselStyles = (theme: Theme): any => {
  return {
    indicatorContainerProps: {
      style: {
        marginTop: "64px",
      },
    },
    indicatorIconButtonProps: {
      style: {
        margin: "8px",
        color: "transparent",
        border: `solid 1px ${theme.palette.secondary.dark}`,
      },
    },
    activeIndicatorIconButtonProps: {
      style: {
        backgroundColor: `${theme.palette.secondary.dark}`,
      },
    },
  };
};
